import styled from 'styled-components'
import theme from 'theme'
import { InvoiceListWrapper } from 'views/Invoices/List/styles'

export const Wrapper = styled(InvoiceListWrapper)`
  margin-top: ${theme.spacing.base};
`
